module.exports = "/images/stripe-black.svg?de707789b856369096ddce94687e22f3";